import { cloneDeep } from 'lodash-es';

export class GeoJsonFeatureCollection implements GeoJSON.FeatureCollection {
    type = 'FeatureCollection' as const;
    features: GeoJSON.Feature[];

    constructor(geojsonFeatures: GeoJSON.Feature[] = []) {
        this.features = cloneDeep(geojsonFeatures);
    }
}
